import Config from "react-global-configuration"
import { DEVICE_POSTMESSAGE_TYPE } from "../data/enums"

const useDeviceUtils = () => {
  const { clientKiosk, clientDevice } = Config.get()

  const canPostMessage = () => !!window.ReactNativeWebView?.postMessage

  const postMessage = (data) => {
    if (!canPostMessage()) return

    window.ReactNativeWebView.postMessage(JSON.stringify(data))
  }

  const postImagesMessage = (uploads, imageIndex = 0) => {
    if ((!clientKiosk && !clientDevice) || !canPostMessage() || !uploads?.length > 0) {
      return
    }

    postMessage({
      type: DEVICE_POSTMESSAGE_TYPE.IMAGES,
      payload: {
        images: [...uploads],
        imageIndex,
      },
    })
  }

  const postDownloadMessage = (payload) => {
    if ((!clientKiosk && !clientDevice) || !canPostMessage() || !payload) return

    console.log("postDownloadMessage", payload)
    console.log(
      "postDownloadMessage(stringified)",
      JSON.stringify({
        type: DEVICE_POSTMESSAGE_TYPE.DOWNLOAD,
        payload,
      })
    )

    postMessage({
      type: DEVICE_POSTMESSAGE_TYPE.DOWNLOAD,
      payload,
    })
  }

  return {
    canPostMessage,
    postImagesMessage,
    postDownloadMessage,
  }
}

export { useDeviceUtils }
